import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, UserPlus } from 'lucide-react';

export default function NewEmployee() {
  const navigate = useNavigate();

  return (
    <div className="new-employee-section">
      <div className="new-employee-card" style={{ maxWidth: 600 }}>
        <button onClick={() => navigate('/')} className="btn btn--ghost" style={{ marginBottom: 20 }}>
          <ArrowLeft size={16} /> Volver
        </button>

        <div className="card card--elevated animate-in" style={{ textAlign: 'center', padding: '48px 32px' }}>
          <UserPlus size={56} color="var(--blue-500)" style={{ marginBottom: 20 }} />
          <h2 className="card__title" style={{ fontSize: '1.4rem', marginBottom: 12 }}>
            Alta de Nuevos Empleados
          </h2>
          <p style={{ color: 'var(--gray-500)', marginBottom: 24, fontSize: '0.95rem', lineHeight: 1.6 }}>
            Si acabas de ser contratado, tu responsable de recursos humanos te
            proporcionará un <strong>enlace personalizado</strong> para completar
            tu proceso de alta.
          </p>
          <div className="alert alert--info" style={{ textAlign: 'left', fontSize: '0.88rem' }}>
            <Mail size={16} style={{ verticalAlign: 'middle', marginRight: 8 }} />
            <strong>¿Ya tienes tu enlace?</strong> Ábrelo directamente desde el mensaje que recibiste.
            El enlace tiene este formato: <code style={{ fontSize: '0.8rem' }}>saeweb.com/onboarding/...</code>
          </div>
          <p style={{ color: 'var(--gray-400)', fontSize: '0.82rem', marginTop: 20 }}>
            Si no has recibido ningún enlace, contacta con tu gerente o con el departamento de recursos humanos.
          </p>
        </div>
      </div>
    </div>
  );
}
